import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-219f524b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-header" }
const _hoisted_2 = { class: "result-info" }
const _hoisted_3 = { class: "result-title" }
const _hoisted_4 = { class: "result-time" }
const _hoisted_5 = { class: "result-content" }
const _hoisted_6 = { class: "info-group" }
const _hoisted_7 = { class: "info-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "托盘码", -1 /* HOISTED */))
const _hoisted_9 = { class: "value code" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "总箱数", -1 /* HOISTED */))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "info-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "总数量", -1 /* HOISTED */))
const _hoisted_15 = { class: "value highlight" }
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "状态", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_19 = { class: "section-title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "📋 箱明细", -1 /* HOISTED */))
const _hoisted_21 = { class: "section-count" }
const _hoisted_22 = { class: "case-list" }
const _hoisted_23 = { class: "case-code" }
const _hoisted_24 = { class: "case-item-code" }
const _hoisted_25 = { class: "case-qty" }
const _hoisted_26 = {
  key: 0,
  class: "more-text"
}
const _hoisted_27 = { class: "info-group" }
const _hoisted_28 = { class: "info-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "箱码", -1 /* HOISTED */))
const _hoisted_30 = { class: "value code" }
const _hoisted_31 = { class: "info-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "物料", -1 /* HOISTED */))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "info-row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "批次", -1 /* HOISTED */))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "info-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "数量", -1 /* HOISTED */))
const _hoisted_39 = { class: "value highlight" }
const _hoisted_40 = { class: "info-row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "可用", -1 /* HOISTED */))
const _hoisted_42 = { class: "value" }
const _hoisted_43 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_44 = { class: "section-title" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🔖 序列号", -1 /* HOISTED */))
const _hoisted_46 = { class: "section-count" }
const _hoisted_47 = { class: "serials-list" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "info-group" }
const _hoisted_50 = { class: "info-row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "物料", -1 /* HOISTED */))
const _hoisted_52 = { class: "value code" }
const _hoisted_53 = { class: "info-row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "名称", -1 /* HOISTED */))
const _hoisted_55 = { class: "value" }
const _hoisted_56 = { class: "info-row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "单位", -1 /* HOISTED */))
const _hoisted_58 = { class: "value" }
const _hoisted_59 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "📦 库存分布", -1 /* HOISTED */))
const _hoisted_61 = { class: "stock-list" }
const _hoisted_62 = { class: "stock-warehouse" }
const _hoisted_63 = { class: "stock-qty" }
const _hoisted_64 = { class: "info-group" }
const _hoisted_65 = { class: "info-row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "库位", -1 /* HOISTED */))
const _hoisted_67 = { class: "value location-value" }
const _hoisted_68 = {
  key: 4,
  class: "error-message"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "error-icon" }, "⚠️", -1 /* HOISTED */))
const _hoisted_70 = {
  key: 5,
  class: "warning-message"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning-icon" }, "⚠️", -1 /* HOISTED */))
const _hoisted_72 = {
  key: 6,
  class: "doc-created"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "doc-icon" }, "✅", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scan-result", { success: $props.result.success, error: !$props.result.success }])
  }, [
    _createCommentVNode(" 结果头部 "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["result-icon", { success: $props.result.success }])
      }, _toDisplayString($props.result.success ? '✓' : '✗'), 3 /* TEXT, CLASS */),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($props.result.success ? '扫描成功' : '扫描失败'), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.formatTime), 1 /* TEXT */)
      ]),
      _createElementVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('confirm'))),
        title: "关闭"
      }, "✕")
    ]),
    _createCommentVNode(" 结果内容 "),
    _createElementVNode("div", _hoisted_5, [
      _createCommentVNode(" 托盘结果 "),
      ($props.result.data?.level === 'PALLET')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString($props.result.data.pallet_code), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString($props.result.data.total_cases || 0), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString($props.result.data.total_quantity || 0), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", {
                  class: _normalizeClass(["value status-badge", $setup.getStatusClass($props.result.data.status)])
                }, _toDisplayString($setup.getStatusText($props.result.data.status)), 3 /* TEXT, CLASS */)
              ])
            ]),
            _createCommentVNode(" 箱明细 "),
            ($props.result.data.cases?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString($props.result.data.cases.length) + "箱", 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.result.data.cases.slice(0, 5), (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c.case_code,
                        class: "case-item"
                      }, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(c.case_code), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(c.item_code), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(c.quantity), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($props.result.data.cases.length > 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 等" + _toDisplayString($props.result.data.cases.length) + "箱 ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : ($props.result.data?.level === 'CASE')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" 箱子结果 "),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString($props.result.data.case_code), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("span", _hoisted_33, _toDisplayString($props.result.data.item_code), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, _toDisplayString($props.result.data.batch_no || '-'), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("span", _hoisted_39, _toDisplayString($props.result.data.quantity || 0), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("span", _hoisted_42, _toDisplayString($props.result.data.available || $props.result.data.quantity || 0), 1 /* TEXT */)
                ])
              ]),
              _createCommentVNode(" 序列号 "),
              ($props.result.data.serials?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("span", _hoisted_46, _toDisplayString($props.result.data.serials.length) + "个", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createTextVNode(_toDisplayString($props.result.data.serials.slice(0, 3).join(', ')) + " ", 1 /* TEXT */),
                      ($props.result.data.serials.length > 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, "等" + _toDisplayString($props.result.data.serials.length) + "个", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : ($props.result.data?.level === 'ITEM')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" 物料结果 "),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("span", _hoisted_52, _toDisplayString($props.result.data.item_code), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("span", _hoisted_55, _toDisplayString($props.result.data.item_name || '-'), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("span", _hoisted_58, _toDisplayString($props.result.data.stock_uom || '-'), 1 /* TEXT */)
                  ])
                ]),
                _createCommentVNode(" 库存分布 "),
                ($props.result.data.stock_balance?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.result.data.stock_balance, (s) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: s.warehouse,
                            class: "stock-item"
                          }, [
                            _createElementVNode("span", _hoisted_62, _toDisplayString(s.warehouse), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_63, _toDisplayString(s.actual_qty), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : ($props.result.data?.level === 'LOCATION')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createCommentVNode(" 库位结果 "),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("span", _hoisted_67, _toDisplayString($props.result.data.warehouse), 1 /* TEXT */)
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
      _createCommentVNode(" 错误信息 "),
      (!$props.result.success && $props.result.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _hoisted_69,
            _createTextVNode(" " + _toDisplayString($props.result.message), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 警告信息 "),
      ($props.result.warning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _hoisted_71,
            _createTextVNode(" " + _toDisplayString($props.result.warning), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 创建的单据 "),
      ($props.result.created_document)
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("span", null, "已创建单据: " + _toDisplayString($props.result.created_document), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}